module.exports = __webpack_public_path__ + "img/virale-video.d60daff.jpg";